import React from 'react';
import { FormattedMessage } from 'react-intl';

type UseQrCodeErrorProps = {
  countdown: number;
  isDisabled: boolean;
  hasCodeError: boolean;
  codeError?: React.ReactNode;
};

const useQrCodeError = ({ isDisabled, hasCodeError, codeError, countdown }: UseQrCodeErrorProps) => {

  if (isDisabled) {
    return (
      <FormattedMessage
        id="login.code.maxAttemptsReached"
        defaultMessage="You have reached the maximum number of attempts. Please try again in {countdown} seconds."
        values={{ countdown }}
      />
    );
  }

  if (hasCodeError) {
    return <FormattedMessage  id="login.code.invalid" defaultMessage="Wrong code, please try again."/>;
  }

  return codeError;
};

export default useQrCodeError;
